import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EmailNotification } from '../../models/email-notification/email-notification.model';

@Injectable({
    providedIn: 'root'
})
export class NotificationsService {
    uri = environment.apiUrl + '/emailNotifications';

    constructor(private readonly http: HttpClient) {}

    public sendEmailNotification(emailNotification: EmailNotification): Observable<void> {
        return this.http.post<void>(this.uri, emailNotification);
    }
}
